import { $lte as __lte, createQueryOperator } from "../../_predicates";
const $lte = createQueryOperator(__lte);
export {
  $lte
};
